<template>
  <div class="cmp-order-product normalize-headers" :class="parentClassRef">

    <utlz-order-normal
      v-if="orderType === 'normal'"
      @orderNormal="orderProductNormal($event)"
    ></utlz-order-normal>

    <!-- <utlz-order-saleunit
      v-if="orderType === 'saleUnit'"
      :saleUnit="product.saleUnit"
    ></utlz-order-saleunit>

    <utlz-order-units
      v-if="orderType === 'units' && product.stock"
      :units="product.units"
      :stockTotal="product.stock.stockTotal"
      :selectedUnitCode="selectedUnitCode"
      @unitsChanged="unitsChanged($event)"
    ></utlz-order-units>

    <utlz-order-grouped v-if="orderType === 'grouped'" :product="product"></utlz-order-grouped> -->

    <!-- BESPOKE -->
    <!-- <utlz-order-volume-discount
      v-if="orderType === 'volumeDiscount'"
      :volumeDiscount="product.prices"
      @volumeDiscountChanged="volumeDiscountChanged($event)">
    </utlz-order-volume-discount> -->
    <!-- END BESPOKE -->

    <template v-if="product.prices[0].rawPrice != 0">
      <input v-if="useOrderComment" type="text" :value="orderCommentField" :placeholder="placeholder" ref="orderComment" class="order-comment">


      <template v-if="orderType === 'units'">

          <!-- BESPOKE DUTCH-78 -->
          <div class="units-qty-btns" v-for="unit in productUnits" :key="'unit-' + unit.code">
            <utlz-quantity-buttons
              :allowZeroQuantity="true"
              :initialQuantity="0"
              :quantityFactor="1"
              @quantityChanged="quantityChangedForProductUnit($event, { unitCode: unit.code })">
            </utlz-quantity-buttons>
            <p class="unit-display">
              {{ unit.description }} (Inhoud: {{ unit.quantity }} Stuks)
            </p>
          </div>
          <!-- END BESPOKE DUTCH-78 -->

          <template v-if="useOrderButtonWithText">
            <a v-if="useOrderMode" @click="orderProductWithUnits" class="button add-to-cart-btn text-btn">
              <i class="uws-icon uws-cart" aria-hidden="true"></i>
              <span class="btn-text" v-translation="{ code: 'button_order', type: 'button' }"></span>
            </a>
          </template>
          <template v-else>
            <a v-if="useOrderMode" @click="orderProductWithUnits" class="button add-to-cart-btn small">
              <i class="uws-icon uws-cart" aria-hidden="true"></i>
            </a>
          </template>
      </template>      

      <template v-else>

        <div class="order-product-wrapper flex-row-nowrap" :class="{ 'disabled': stockLimit && !isValidQuantity }">
          <utlz-quantity-buttons
            :allowZeroQuantity="true"
            :initialQuantity="quantity"
            :quantityFactor="quantityFactor"
            @quantityChanged="quantityChanged($event)">
          </utlz-quantity-buttons>

          <template v-if="useOrderButtonWithText">
            <a v-if="useOrderMode" @click="orderProduct" class="button add-to-cart-btn text-btn">
              <i class="uws-icon uws-cart" aria-hidden="true"></i>
              <span class="btn-text" v-translation="{ code: 'button_order', type: 'button' }"></span>
            </a>
          </template>
          <template v-else>
            <a v-if="useOrderMode" @click="orderProduct" class="button add-to-cart-btn small">
              <i class="uws-icon uws-cart" aria-hidden="true"></i>
            </a>
          </template>

        <!-- Displays stocklimit exceeded tooltip -->
        <transition name="fade">
          <template v-if="stockLimit && !isValidQuantity">
            <div class="utlz-tooltip stock-limit danger">
              <p v-translation="{ type: 'label', code: 'label_exceeds_stock_limit' }"></p>
            </div>
          </template>
        </transition>
      </div>
      </template>
      
    </template>
    <template v-else>
      <a :href="getPriceOnRequestUrl" class="button add-to-cart-btn text-btn price-req-btn" v-translation="{ code: 'link_price_onrequest', type: 'button' }">
      </a>
    </template>

  </div>
</template>

<script>
import OrderNormal from 'src/components/webshop/order-product/blocks/OrderNormal.vue';
import OrderSaleUnit from 'src/components/webshop/order-product/blocks/OrderSaleUnit.vue';
import OrderUnits from 'src/components/webshop/order-product/blocks/OrderUnits.vue';
import OrderGrouped from 'src/components/webshop/order-product/blocks/OrderGrouped.vue';
import OrderVolumeDiscount from 'src/components/webshop/order-product/blocks/OrderVolumeDiscount.vue';
import QuantityButtons from 'src/components/webshop/order-product/blocks/QuantityButtons.vue';
import { mapGetters, mapActions } from 'vuex';

export default {
  components: {
    'utlz-order-normal': OrderNormal,
    'utlz-order-saleunit': OrderSaleUnit,
    'utlz-order-units': OrderUnits,
    'utlz-order-grouped': OrderGrouped,
    'utlz-order-volume-discount': OrderVolumeDiscount,
    'utlz-quantity-buttons': QuantityButtons
  },
  props: {
    product: { type: Object, required: true },
    initialQuantity: { type: Number, required: false, default: 1 },
    initialUnitCode: { type: String, required: false },
    useOrderComment: { type: Boolean, required: false, default: false },
    orderComment: { type: String, required: false },
    useOrderMode: { type: Boolean, default: true },
    totalOrderLinesQuantity: { type: Number, required: false, default: null },
    allowZeroQuantity: { type: Boolean, required: false, default: false },
    parentClassRef: { type: String, default: '', required: false },
    // BESPOKE
    useOrderButtonWithText: { type: Boolean, default: false },
    useMultipleQuantityButtonsForUnits: { type: Boolean, default: false }
    // END BESPOKE
  },
  data () {
    return {
      stockProduct: this.product.customBooleans.STOCK_PRODUCT,
      quantity: this.initialQuantity,
      quantityFactor: 1,
      orderType: 'normal',
      selectedUnitCode: '',
      // BESPOKE
      placeholder: window.vue.translations.label.label_orderline_comment_ph,
      productUnits: []
      // END BESPOKE
    };
  },
  computed: {
    ...mapGetters(['stockLimit', 'showStock', 'bespokeGlobalWs']),
    // BEPOKE DUTCH-74
    getPriceOnRequestUrl() {
      var url = new URL(`${this.bespokeGlobalWs.priceOnRequestUrl}`, document.location);
      url.searchParams.append('prodCode', this.product.id);
      url.searchParams.append('prodDesc', this.product.shortDescription);
      
      var prodDesc2 = this.product.customStrings.PROD_DESC2;
      if (prodDesc2 !== undefined) {
        url.searchParams.append('prodDesc2', prodDesc2);
      }
      return url;
    },
    // END BEPOKE DUTCH-74
    orderCommentField () {
      return this.orderComment;
    },
    isValidQuantity () {
      if (this.stockLimit && this.stockProduct && this.product.stock.stockTotal !== null) {
        if (this.useOrderMode || this.totalOrderLinesQuantity === null) {
          return this.quantity <= this.product.stock.stockTotal;
        } else {
          return this.totalOrderLinesQuantity <= this.product.stock.stockTotal;
        }
      } else {
        return true;
      }
    }
  },
  watch: {
    product () {
      this.setOrderType();
      this.setOrderQuantities();
    }
  },
  methods: {
    setOrderType () {
      let type = 'normal';
      if (this.product.units) {
        
        // BESPOKE DUTCH
        // If a product has a unit, show order product with a units display,
        // but only if there are more than 1 unit which has a higher quantity than 1
        if (this.product.units[0].quantity > 1) {

          this.product.units.forEach(x => {
          this.productUnits.push({
            code: x.code,
            description: x.description,
            quantity: x.quantity,
            userQuantity: 0
          });

          type = 'units';
        });
        // END BESPOKE DUTCH
        }
        
      } else if (this.product.saleUnit > 1) {
        type = 'saleUnit';
      }
      this.orderType = type;
    },
    setOrderQuantities () {
      switch (this.orderType) {
        case 'normal':
          this.quantityFactor = 1;
          if (this.allowZeroQuantity) {
            this.quantity = 0;
          } else {
            this.quantity = this.initialQuantity > this.quantityFactor ? this.initialQuantity : this.quantityFactor;
          }
          break;
        case 'saleUnit':
          const initialQuantity = this.initialQuantity * this.product.saleUnit;
          this.quantityFactor = this.product.saleUnit;
          if (this.allowZeroQuantity) {
            this.quantity = 0;
          } else {
            this.quantity = initialQuantity > this.quantityFactor ? initialQuantity : this.quantityFactor;
          }
          break;
        case 'volumeDiscount':
          this.quantityFactor = this.product.prices[0].quantity;
          this.quantity = this.initialQuantity > this.quantityFactor || this.allowZeroQuantity ? 0 : this.quantityFactor;
          break;
        case 'units':
          let index = 0;
          if (this.initialUnitCode) {
            this.product.units.filter((unit, i) => {
              if (unit.code === this.initialUnitCode) {
                index = i;
              }
            });
          }
          this.selectedUnitCode = this.product.units[index].code;
          this.quantityFactor = this.product.units[index].quantity;
          if (this.allowZeroQuantity) {
            this.quantity = 0;
          } else {
            this.quantity = this.initialQuantity > 1 ? this.initialQuantity * this.quantityFactor : this.quantityFactor;
          }
          break;
      }
    },
    orderProduct () {
      let payload = this.getOrderPayload();
      this.addToCart(payload)
        .then(res => {
          this.quantity = this.quantityFactor;
        });
    },
    // BESPOKE DUTCH-78
    // If orderType === 'units' we update the units state array with the quantities
    // so we can create an orderProduct payload based on this state when clicking the order button
    quantityChangedForProductUnit (quantity, { unitCode }) {
      var unitIndex = this.productUnits.findIndex(x => x.code === unitCode);
      this.productUnits[unitIndex].userQuantity = quantity.quantity;
    },
    orderProductWithUnits() {
      var payload = [];
      
      this.productUnits.forEach(unit => {
        if (unit.userQuantity > 0) {
          payload.push({
            prod_code: this.product.id,
            ord_qty: unit.userQuantity,
            unit_code: unit.code,
            prod_comment: this.useOrderComment ? this.$refs.orderComment.value : ''
          });
        }
      });

      if (payload.length > 0) {
        this.addToCart(payload)
        .then(res => {
          
        });
      }
    },
    // END BESPOKE DUTCH-78
    getOrderPayload () {
      // BESPOKE DUTCH-78
      // Some products have one unit with a quantity of 1, in which case we use the order product
      // without the unit quantity display since showing 1 x 1 makes no sense. However when ordering the
      // product we still need to get this unit code manually
      var unitCode = this.selectedUnitCode;
      if (this.product.units !== null) {
        if (this.product.units.length == 1 && this.product.units[0].quantity == 1)
        unitCode = this.product.units[0].code;
      }
      return {
        prod_code: this.product.id,
        ord_qty: this.getComputedQuantity(this.quantity),
        unit_code: unitCode,
        prod_comment: this.useOrderComment ? this.$refs.orderComment.value : ''
      }
      // END BESPOKE DUTCH-78
    },
    getComputedQuantity (quantity) {
      let computedQuantity = quantity;
      if (this.orderType === 'units') {
        computedQuantity = this.quantity / this.quantityFactor;
      } else if (this.orderType === 'volumeDiscount' && this.product.saleUnit > 1) {
        computedQuantity = this.quantity / this.product.saleUnit;
      } else if (this.orderType === 'saleUnit') {
        computedQuantity = this.quantity / this.product.saleUnit;
      }
      return computedQuantity;
    },
    quantityChanged ({ quantity }) {
      this.quantity = quantity;
      if (!this.useOrderMode) {
        this.$emit('quantityChanged', {
          id: this.product.id,
          unitCode: this.selectedUnitCode,
          computedQuantity: this.getComputedQuantity(this.quantity)
        });
      }
    },
    unitsChanged ({ quantity, unitCode }) {
      this.selectedUnitCode = unitCode;
      this.quantity = this.allowZeroQuantity ? 0 : quantity;
      this.quantityFactor = quantity;
      if (!this.useOrderMode) {
        this.$emit('unitsChanged', {
          unitCode: unitCode,
          quantity: quantity,
          computedQuantity: this.getComputedQuantity(this.quantity)
        });
      }
    },
    volumeDiscountChanged (quantity) {
      this.quantity = quantity;
      this.quantityFactor = quantity;
    },
    ...mapActions('shoppingCart', ['addToCart'])
  },
  created () {
    this.setOrderType();
    this.setOrderQuantities();
  }
};
</script>

<style>
</style>
